import { type FC } from 'react';
import { useUnit } from 'effector-react';
import { useNavigate } from 'react-router';
import { Button, Group, Stack } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { createPayoutCascadeUrl, type PayoutCascade } from '~/entities/payout';
import { CascadesFilter } from './components/CascadesFilter';
import { CascadesList } from './components/CascadesList';
import { $cascadesFilter, paginationModel } from './model';

export const Cascades: FC = () => {
    const filter = useUnit($cascadesFilter);
    const navigate = useNavigate();

    const handleRowClick = (cascade: PayoutCascade) => {
        if (cascade.id?.value) {
            navigate(createPayoutCascadeUrl(cascade.id.value));
        }
    };

    return (
        <Stack gap='sm'>
            <Group justify='space-between'>
                <CascadesFilter />

                <Button
                    leftSection={<IconPlus size={16} />}
                    onClick={() => navigate(createPayoutCascadeUrl())}
                >
                    Создать каскад
                </Button>
            </Group>

            <CascadesList
                filter={filter}
                paginationModel={paginationModel}
                onClick={handleRowClick}
            />
        </Stack>
    );
};
